import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

const initialState: OfferCategory = {
  OfferCategoryID: null,
  TenantID: null,
  CategoryName: '',
  WebUiPosition: null,
  iconImageUrl: '',
  Offers: [],
  Name: '',
  selectedLanguage: '',
  selectedLanguageName: '',
  defaultLanguage: {
    Name: null
  },
  translations: {
    Name: null,
    LanguageCode: null
  }
}
export const offerCategorySlice = createSlice({
  name: 'offerCategory',
  initialState,
  reducers: {
    setOfferCategoryInfo: (state, action: PayloadAction<OfferCategory>) => {
      return {
        ...state,
        ...action.payload
      }
    },
    setOfferCategorySelectedTranslations: (
      state,
      action: PayloadAction<SetCategoryTranslationParms>
    ) => {
      return {
        ...state,
        selectedLanguage: action.payload.selectedLanguage,
        selectedLanguageName: action.payload.selectedLanguageName,
        defaultLanguage: action.payload.defaultLanguage,
        translations: {
          Name: action.payload.translations?.Name ?? null,
          LanguageCode: action.payload.selectedLanguage
        }
      }
    }
  }
})
export const { setOfferCategoryInfo, setOfferCategorySelectedTranslations } =
  offerCategorySlice.actions
export const offerCategoryReducer = offerCategorySlice.reducer
